var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _ellipse2, _path16, _g2, _g3, _path17, _g4, _path18, _g5, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFandb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 512,
    viewBox: "0 0 520 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6537_40003)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.638 488.825C443.182 496.94 427.526 502.802 410.269 506.609C398.296 509.195 386.135 510.82 373.904 511.468C327.185 514.324 273.462 505.557 221.691 488.023C210.086 484.115 198.582 479.757 187.277 474.948C103.092 439.479 29.9122 381.567 9.4037 314.437C-28.0617 191.9 52.3714 103.779 145.51 22.923C183.275 -9.89052 232.496 -5.18141 283.417 22.5222C295.856 29.3549 307.822 37.0205 319.231 45.4666C364.1 78.4805 408.518 126.523 446.034 179.927C519.664 284.78 562.281 425.252 456.638 488.825Z",
    fill: "#E8E8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.472 350.848L206.193 327.512L237.395 373.979C219.166 389.203 188.544 400.274 172.72 396.893C140.246 389.955 74.6224 297.682 65.5172 290.658C34.5192 266.743 24.4427 257.667 63.2309 276.25C100.211 293.967 80.6247 276.25 89.685 276.25C100.57 277.011 96.9628 286.678 92.9226 293.606L166.472 350.848Z",
    fill: "url(#paint0_linear_6537_40003)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M403.853 308.496C392.646 300.708 348.364 286.679 328.916 280.639L308.341 282.885C295.377 286.101 267.57 291.585 254.78 296.774C241.989 301.964 218.777 318.512 197.122 332.313L202.239 350.05C206.828 365.955 218.97 378.571 234.688 383.766C238.733 409.507 242.221 451.356 241.645 464.329L392.131 464.212L399.02 400.517L430.009 403.839L456.186 383.766C423.409 327.03 417.861 318.232 403.853 308.496Z",
    fill: "url(#paint1_linear_6537_40003)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M446.904 454.86C494.585 448.81 463.573 400.449 455.12 384.478C444.895 393.091 432.266 398.347 418.95 399.531L402.525 400.991L409.253 416.524L336.614 433.543L326.423 461.835C333.681 460.598 387.611 462.384 446.904 454.86Z",
    fill: "url(#paint2_linear_6537_40003)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M329.844 153.669C327.497 149.422 320.767 143.477 312.619 153.669H329.844Z",
    fill: "#30235B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.9725,
    cy: 18.5221,
    rx: 25.9725,
    ry: 18.5221,
    transform: "matrix(-1 0 0 1 351.906 280.639)",
    fill: "#4D3ECC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M347.215 298.165L343.584 261.99H308.239L304.179 298.165C305.598 302.426 312.298 311.068 324.705 311.068C340.517 311.068 346.201 302.426 347.215 298.165Z",
    fill: "url(#paint3_linear_6537_40003)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6537_40003",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 304,
    y: 261,
    width: 44,
    height: 51
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M347.215 298.165L343.584 261.99H308.239L304.172 298.239C305.591 302.499 312.313 311.069 324.72 311.069C340.533 311.069 346.201 302.426 347.215 298.165Z",
    fill: "url(#paint4_linear_6537_40003)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6537_40003)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M295.5 263.374C327.459 302.946 345.318 271.128 354.543 266.355L348.204 239.603L310.362 235.081L295.5 263.374Z",
    fill: "#263238"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M326.545 276.512C364.662 276.512 371.217 221.756 359.44 196.711C332.941 164.3 299.818 183.206 286.569 196.711C283.379 217.582 279.862 276.512 326.545 276.512Z",
    fill: "url(#paint5_linear_6537_40003)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M285.918 234.623L293.386 229.117L292.23 225.019L283.701 230.647L285.918 234.623Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M363.723 233.027L356.255 227.521L357.41 223.422L365.94 229.051L363.723 233.027Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M356.889 200.002C329.865 217.622 299.907 207.344 288.306 200.002C290.749 207.712 287.288 222.532 285.253 228.978C267.669 206.062 273.417 193.688 278.49 190.365C279.335 178.944 289.71 150.388 324.539 151.742C359.368 153.095 366.127 177.816 365.14 186.981C378.328 204.916 370.482 222.452 364.121 228.978C356.889 214.927 357.054 205.07 356.889 200.002Z",
    fill: "#30235B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M342.971 241.019C348.364 241.019 351.079 236.766 351.769 234.866C352.563 233.278 353.189 229.14 351.31 225.853C348.921 221.674 337.692 220.508 333.759 226.413C329.825 232.317 333.759 241.019 342.971 241.019Z",
    fill: "#E6FCFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M307.24 241.019C301.847 241.019 299.132 236.766 298.442 234.866C297.648 233.278 297.022 229.14 298.9 225.853C301.29 221.674 312.519 220.508 316.452 226.413C320.386 232.317 316.452 241.019 307.24 241.019Z",
    fill: "#E6FCFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.973 225.11C339.767 217.381 347.711 220.651 352.418 222.589C352.942 222.804 353.425 223.003 353.865 223.169L356.812 223.174C357.367 223.175 357.815 223.628 357.811 224.183L357.789 226.664C357.784 227.213 357.337 227.655 356.789 227.655L354.658 227.655C356.201 240.916 346.429 244.465 338.614 242.075C331.646 239.944 329.781 233.914 329.408 230.131C327.918 226.826 321.384 228.353 321.125 230.058C321.121 230.085 321.117 230.114 321.112 230.145C321.11 230.16 321.107 230.176 321.105 230.192C320.798 232.267 319.253 242.723 307.49 242.738C297.855 242.75 295.242 234.136 295.14 229.827L292.646 229.805C292.093 229.8 291.65 229.349 291.655 228.796L291.681 225.762C291.686 225.209 292.138 224.766 292.69 224.771L295.184 224.793C301.461 218.43 314.942 219.025 319.691 225.01C324.93 223.801 329.395 224.573 330.973 225.11ZM342.972 241.019C348.364 241.019 351.08 236.766 351.77 234.867C352.563 233.278 353.19 229.14 351.311 225.853C348.922 221.674 337.693 220.508 333.759 226.413C329.826 232.317 333.759 241.019 342.972 241.019ZM298.441 234.867C299.131 236.766 301.846 241.019 307.239 241.019C316.451 241.019 320.385 232.317 316.451 226.413C312.518 220.508 301.288 221.674 298.899 225.853C297.02 229.14 297.647 233.278 298.441 234.867Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M395.318 458.962C395.318 458.407 394.868 457.957 394.313 457.957H239.923C238.952 457.957 238.164 458.745 238.164 459.716C238.164 462.631 240.527 464.994 243.442 464.994H389.286C392.618 464.994 395.318 462.294 395.318 458.962Z",
    fill: "#B4B4B4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 157.155,
    height: 105.226,
    rx: 2.94666,
    transform: "matrix(-1 0 0 1 395.318 355.345)",
    fill: "url(#paint6_linear_6537_40003)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1765,
    cy: 11.1849,
    rx: 11.1765,
    ry: 11.1849,
    transform: "matrix(-1 0 0 1 333.918 396.773)",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M398.288 99.0005C398.288 102.778 401.349 105.841 405.123 105.841C408.898 105.841 411.958 102.778 411.958 99.0005C411.958 95.2227 408.898 92.1604 405.123 92.1604C401.349 92.1604 398.288 95.2227 398.288 99.0005Z",
    stroke: "#F7F7F7",
    strokeWidth: 0.321779
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6537_40003)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 62.1425,
    height: 48.4583,
    rx: 3.49287,
    transform: "matrix(-1 0 0 1 296.143 57.9995)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.001 69.1995C255.233 69.1995 253.801 70.6322 253.801 72.3995V94.7995L259.401 91.5995L265.001 94.7995L270.601 91.5995L276.201 94.7995V72.3995C276.201 70.6322 274.768 69.1995 273.001 69.1995H257.001ZM261.001 73.9995C259.675 73.9995 258.601 75.074 258.601 76.3995C258.601 77.7249 259.675 78.7995 261.001 78.7995C262.326 78.7995 263.401 77.7249 263.401 76.3995C263.401 75.074 262.326 73.9995 261.001 73.9995ZM270.932 74.4681C270.307 73.8433 269.294 73.8433 268.669 74.4681L259.069 84.0681C258.445 84.6929 258.445 85.706 259.069 86.3308C259.694 86.9557 260.707 86.9557 261.332 86.3308L270.932 76.7308C271.557 76.106 271.557 75.0929 270.932 74.4681ZM269.001 81.9995C267.675 81.9995 266.601 83.074 266.601 84.3995C266.601 85.7249 267.675 86.7995 269.001 86.7995C270.326 86.7995 271.401 85.7249 271.401 84.3995C271.401 83.074 270.326 81.9995 269.001 81.9995Z",
    fill: "#FFC34E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_d_6537_40003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.3643,
    height: 44.7323,
    rx: 4.74712,
    transform: "matrix(-1 0 0 1 228.363 165)",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.158 174.537C192.23 174.537 191.478 175.255 191.478 176.14V177.743H189.797C187.94 177.743 186.436 179.179 186.436 180.95V196.981C186.436 198.751 187.94 200.187 189.797 200.187H209.965C211.822 200.187 213.327 198.751 213.327 196.981V180.95C213.327 179.179 211.822 177.743 209.965 177.743H208.285V176.14C208.285 175.255 207.532 174.537 206.604 174.537C205.676 174.537 204.923 175.255 204.923 176.14V177.743H194.839V176.14C194.839 175.255 194.087 174.537 193.158 174.537ZM193.158 182.553C192.23 182.553 191.478 183.27 191.478 184.156C191.478 185.041 192.23 185.759 193.158 185.759H206.604C207.532 185.759 208.285 185.041 208.285 184.156C208.285 183.27 207.532 182.553 206.604 182.553H193.158Z",
    fill: "#87B4FF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6537_40003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.584,
    height: 67.5319,
    rx: 4.74712,
    transform: "matrix(-1 0 0 1 146.584 53.9995)",
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.092 72.8895C100.416 72.503 99.5856 72.503 98.9093 72.8895L83.5093 81.6895C82.4543 82.2923 82.0878 83.6362 82.6906 84.6911C83.0963 85.401 83.8375 85.7991 84.6004 85.8V101.2C83.3854 101.2 82.4004 102.185 82.4004 103.4C82.4004 104.615 83.3854 105.6 84.6004 105.6H115.4C116.615 105.6 117.6 104.615 117.6 103.4C117.6 102.185 116.615 101.2 115.4 101.2V85.8C116.164 85.7994 116.905 85.4012 117.311 84.6911C117.914 83.6362 117.547 82.2923 116.492 81.6895L101.092 72.8895ZM91.2004 87.9996C89.9854 87.9996 89.0004 88.9846 89.0004 90.1996V96.7996C89.0004 98.0146 89.9854 98.9996 91.2004 98.9996C92.4154 98.9996 93.4004 98.0146 93.4004 96.7996V90.1996C93.4004 88.9846 92.4154 87.9996 91.2004 87.9996ZM97.8004 90.1996C97.8004 88.9846 98.7854 87.9996 100 87.9996C101.215 87.9996 102.2 88.9846 102.2 90.1996V96.7996C102.2 98.0146 101.215 98.9996 100 98.9996C98.7854 98.9996 97.8004 98.0146 97.8004 96.7996V90.1996ZM108.8 87.9996C107.585 87.9996 106.6 88.9846 106.6 90.1996V96.7996C106.6 98.0146 107.585 98.9996 108.8 98.9996C110.015 98.9996 111 98.0146 111 96.7996V90.1996C111 88.9846 110.015 87.9996 108.8 87.9996Z",
    fill: "#FF7979"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_d_6537_40003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.5329,
    height: 65.1384,
    rx: 4.74712,
    transform: "matrix(-1 0 0 1 112.533 184)",
    fill: "white"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 236C81.4934 236 90 227.493 90 217C90 206.506 81.4934 198 71 198C60.5066 198 52 206.506 52 217C52 227.493 60.5066 236 71 236ZM63.8751 205.125C62.5634 205.125 61.5001 206.188 61.5001 207.5C61.5001 208.811 62.5634 209.875 63.8751 209.875H66.2501C68.0082 209.875 69.5433 210.83 70.3646 212.25H63.8751C62.5634 212.25 61.5001 213.313 61.5001 214.625C61.5001 215.936 62.5634 217 63.8751 217H70.3646C69.5433 218.419 68.0082 219.375 66.2501 219.375H63.8751C62.9145 219.375 62.0485 219.953 61.6809 220.841C61.3133 221.728 61.5164 222.75 62.1957 223.429L69.3207 230.554C70.2482 231.481 71.752 231.481 72.6794 230.554C73.6069 229.626 73.6069 228.123 72.6794 227.195L69.1561 223.672C72.2403 222.682 74.6377 220.159 75.4508 217H78.1251C79.4367 217 80.5001 215.936 80.5001 214.625C80.5001 213.313 79.4367 212.25 78.1251 212.25H75.4508C75.2339 211.407 74.9044 210.61 74.4791 209.875H78.1251C79.4367 209.875 80.5001 208.811 80.5001 207.5C80.5001 206.188 79.4367 205.125 78.1251 205.125H63.8751Z",
    fill: "url(#paint7_linear_6537_40003)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6537_40003",
    x: 214,
    y: 47.9995,
    width: 102.143,
    height: 88.4584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368314 0 0 0 0 0.313726 0 0 0 0 0.996078 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6537_40003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6537_40003",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6537_40003",
    x: 150.998,
    y: 155,
    width: 97.3652,
    height: 84.7323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.34102 0 0 0 0 0.996078 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6537_40003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6537_40003",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6537_40003",
    x: 34,
    y: 43.9995,
    width: 132.584,
    height: 107.532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.450196 0 0 0 0 0.313726 0 0 0 0 0.996078 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6537_40003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6537_40003",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6537_40003",
    x: 9,
    y: 174,
    width: 123.533,
    height: 105.138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368314 0 0 0 0 0.313726 0 0 0 0 0.996078 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6537_40003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6537_40003",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6537_40003",
    x1: 156.34,
    y1: 215.408,
    x2: 153.689,
    y2: 391.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6537_40003",
    x1: 316.845,
    y1: 250.327,
    x2: 316.845,
    y2: 499.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6153FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#260CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6537_40003",
    x1: 331.91,
    y1: 337.667,
    x2: 450.615,
    y2: 394.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677966,
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6537_40003",
    x1: 326.916,
    y1: 223.073,
    x2: 324.833,
    y2: 289.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6537_40003",
    x1: 326.916,
    y1: 223.073,
    x2: 329.835,
    y2: 298.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6537_40003",
    x1: 323.458,
    y1: 187.655,
    x2: 323.458,
    y2: 267.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6537_40003",
    x1: 111.028,
    y1: -78.9721,
    x2: 52.8416,
    y2: 129.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171777,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6537_40003",
    x1: 71,
    y1: 198,
    x2: 71,
    y2: 236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7087FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#B6B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B9FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6537_40003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFandb);
export default __webpack_public_path__ + "static/media/fandb.419dabeb1e06e9bc69d3ae2dd49bfbff.svg";
export { ForwardRef as ReactComponent };